var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConversationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4167 5.66666H17.5833V13.9166H5.66667V15.75C5.66667 16.2541 6.07917 16.6666 6.58333 16.6666H16.6667L20.3333 20.3333V6.58333C20.3333 6.07916 19.9208 5.66666 19.4167 5.66666ZM15.75 11.1667V2.91667C15.75 2.4125 15.3375 2 14.8333 2H2.91667C2.4125 2 2 2.4125 2 2.91667V15.75L5.66667 12.0833H14.8333C15.3375 12.0833 15.75 11.6708 15.75 11.1667Z",
    fill: "#4A4A4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationIcon);
export default __webpack_public_path__ + "static/media/conversationIcon.1d37d92ba1859ad569124f2b1637b76b.svg";
export { ForwardRef as ReactComponent };